import axios from '../assets/axios'
export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    // 推荐记录
    async OWNRecommendX ({ commit }, params) {
      const response = await axios.post('/activity/old-with-new/v1/recommend', params)
      return response.data
    },
    // 老带新
    async ownActiveDetail (store, params) {
      const response = await axios.post('/activity/old-with-new/v1/activityDetail', params)
      return response.data
    },
    async ownActiveShareCode (store, params) {
      const response = await axios.post('/activity/old-with-new/v1/getShardCode', params)
      return response.data
    }
  }
}
